/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chatcaselabel2Inputs */

const en_chatcaselabel2 = /** @type {(inputs: Chatcaselabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`case`)
};

const pt_chatcaselabel2 = /** @type {(inputs: Chatcaselabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`caso`)
};

/**
* | output |
* | --- |
* | "case" |
*
* @param {Chatcaselabel2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const chatcaselabel2 = /** @type {((inputs?: Chatcaselabel2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chatcaselabel2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chatcaselabel2(inputs)
	return pt_chatcaselabel2(inputs)
});
export { chatcaselabel2 as "chatCaseLabel" }